export default class JobRequirementsSummaryDto {
    title = '';
    summary = ''
}
